import { useEffect, useState } from 'react';
import { fetchChatAttachmentBlob } from '../api/client.js';

export function ChatMessageBody({ message, attachmentAuth = {}, galleryId = 'chat' }) {
  const att = message.attachment;

  if (!att) {
    return message.body ? <div>{message.body}</div> : null;
  }

  return (
    <div>
      {att.is_image ? (
        <ChatMessageImage
          messageId={message.id}
          attachment={att}
          attachmentAuth={attachmentAuth}
          galleryId={galleryId}
        />
      ) : (
        <ChatMessageFile messageId={message.id} attachment={att} attachmentAuth={attachmentAuth} />
      )}
      {message.body && message.body !== att.original_name ? (
        <div className="muted small" style={{ marginTop: 4 }}>
          {message.body}
        </div>
      ) : null}
    </div>
  );
}

function ChatMessageImage({ messageId, attachment, attachmentAuth, galleryId }) {
  const [src, setSrc] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    let objectUrl = null;
    let cancelled = false;
    fetchChatAttachmentBlob(messageId, attachmentAuth)
      .then((blob) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setSrc(objectUrl);
      })
      .catch((e) => {
        if (!cancelled) setErr(e.message);
      });
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [messageId, attachmentAuth?.guestToken, attachmentAuth?.organizationId]);

  if (err) return <p className="err small">{err}</p>;
  if (!src) return <p className="muted small">Loading image…</p>;

  return (
    <a
      href={src}
      data-fancybox={galleryId}
      data-caption={attachment.original_name}
      aria-label={`Open ${attachment.original_name}`}
      className="chat-image-thumb"
    >
      <img
        src={src}
        alt={attachment.original_name}
        style={{ maxWidth: '100%', maxHeight: 200, borderRadius: 6, display: 'block', cursor: 'zoom-in' }}
      />
    </a>
  );
}

function ChatMessageFile({ messageId, attachment, attachmentAuth }) {
  const [downloading, setDownloading] = useState(false);

  const download = async () => {
    setDownloading(true);
    try {
      const blob = await fetchChatAttachmentBlob(messageId, attachmentAuth);
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = attachment.original_name;
      a.click();
      URL.revokeObjectURL(url);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <button type="button" className="btn-link" onClick={() => void download()} disabled={downloading}>
      📎 {attachment.original_name}
      {downloading ? ' …' : ''}
    </button>
  );
}
